import React from 'react';
import { Label } from '../Label';
import { I18n } from 'js/components/common/I18n';
import buildClassName from 'js/utils/classNameBuilder.util';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import * as helpers from './helpers';

import style from './Control.scss';

export const Control = ({
    id,
    meta: { active, touched, submitting, validating, submitError, error = submitError, customError } = {},
    label,
    hint,
    readOnly,
    classNames = {},
    className = '',
    onClick,
    animate,
    children,
    bottomHint,
    disabled = false,
    isBorderHidden = false,
    infoTooltip = '',
    isLabelAsteriskEnabled = false,
    ...props // data attributes
}) => {
    const modeClassName = helpers.getModeClass({
        error: customError || error, touched,
        active, submitting, validating, disabled, readOnly
    });
    const controlClassName = buildClassName(['control', modeClassName], style, classNames);
    const bottomHintClassName = buildClassName(['bottomHint'], style, classNames);

    const bottomHintContent = typeof bottomHint === 'string'
        ? <I18n tKey={bottomHint} defaultValue={bottomHint} className={bottomHintClassName} />
        : <span className={bottomHintClassName}>{bottomHint}</span>;

    return (
        <div
            onClick={onClick}
            className={`${controlClassName} ${isBorderHidden ? style.hideBorder : ''} ${className} control-${modeClassName}`}
        >
            {(label || isLabelAsteriskEnabled) && (
                <Label
                    id={id}
                    hint={hint}
                    label={label}
                    readOnly={readOnly}
                    classNames={classNames}
                    infoTooltip={infoTooltip}
                    isLabelAsteriskEnabled={isLabelAsteriskEnabled}
                />
            )}

            <div
                className={`${buildClassName(['content'], style, classNames)} cms-control-content`}
                {...props}
            >
                {children}
            </div>

            {bottomHint && bottomHintContent}

            {(error && touched && !active && !validating || customError) && (
                <ErrorMessage
                    error={customError || error}
                    animate={animate}
                    classNames={{ error: style.error, ...classNames }}
                />
            )}
        </div>
    );
};
